import React from 'react'
import QrBase from '../../qr-section.connect'

const QrModalWrapper = () => (
  <QrBase isModal />
)

export default QrModalWrapper
